<!--车头编辑页面-->
<template>
  <div>
    <div class="content">
      <van-form
        @submit="submitJsy"
        @failed="formCheckFailed"
        :validate-first="true"
        :scroll-to-error="true"
      >
        <!--仅蒸洗表单内容-->
        <van-cell-group inset>
          <!--车辆用途选择器-->
          <ChoseVehicleUsage
            :options="usageList"
            :modelValue="usageType"
            @update:modelValue="usageType = $event"
            @change="changeVehicleUsage"
            :disabled="usageDisabled"
          />
          <div class="upload-box">
            <!--上传行驶证正页-->
            <div>
              <h2 class="upload-titile input-title-hq">
                行驶证正页
                <span class="image-show" @click="showImageDemo('zbfm')">（示例:如图）</span>
              </h2>
              <van-field
                name="xingshizhengzbfmurl"
                :required="true"
                :rules="[{ required: true, message: '请上传行驶证正页' }]"
              >
                <template #input>
                  <van-uploader
                    :max-size="10 * 1024 * 1024"
                    @oversize="onOversize"
                    max-count="1"
                    v-model="xsz_zb_fm_image"
                    :before-read="beforeRead"
                    :after-read="
                      ($event) => {
                        uploadImg($event, 'xsz_zb_fm', 'xingshizhengzbfmurl', 'uploadXsz');
                      }
                    "
                    :before-delete="
                      () => {
                        removePic('xsz_zb_fm');
                      }
                    "
                  ></van-uploader>
                </template>
              </van-field>
            </div>
            <!--上传行驶证副页-->
            <div v-if="usageType === '2'">
              <h2 class="upload-titile input-title-hq">
                行驶证副页
                <span class="image-show" @click="showImageDemo('fbzm')">（示例:如图）</span>
              </h2>
              <van-field
                name="xingshizhengfbzmurl"
                :required="true"
                :rules="[{ required: true, message: '请上传行驶证副页' }]"
              >
                <template #input>
                  <van-uploader
                    :max-size="10 * 1024 * 1024"
                    @oversize="onOversize"
                    max-count="1"
                    v-model="xsz_fb_zm_image"
                    :before-read="beforeRead"
                    :after-read="
                      ($event) => {
                        uploadImg($event, 'xsz_fb_zm', 'xingshizhengfbzmurl', 'uploadXsz');
                      }
                    "
                    :before-delete="
                      () => {
                        removePic('xsz_fb_zm');
                      }
                    "
                  ></van-uploader>
                </template>
              </van-field>
            </div>
            <!--上传行驶证副页反面-->
            <div v-if="usageType === '2'">
              <h2 class="upload-titile input-title-hq">
                行驶证副页反面
                <span class="image-show" @click="showImageDemo('fbfm')">（示例:如图）</span>
              </h2>
              <van-field
                name="xingshizhengfbfmurl"
                required
                :rules="[{ required: true, message: '请上传行驶证副页反面' }]"
              >
                <template #input>
                  <van-uploader
                    :max-size="10 * 1024 * 1024"
                    @oversize="onOversize"
                    max-count="1"
                    v-model="xsz_fb_fm_image"
                    :before-read="beforeRead"
                    :after-read="
                      ($event) => {
                        uploadImg($event, 'xsz_fb_fm', 'xingshizhengfbfmurl', 'uploadXsz');
                      }
                    "
                    :before-delete="
                      () => {
                        removePic('xsz_fb_fm');
                      }
                    "
                  ></van-uploader>
                </template>
              </van-field>
            </div>
            <!--上传行驶证机动车照片-->
            <div v-if="usageType === '2'">
              <h2 class="upload-titile input-title-hq">
                行驶证机动车照片
                <span class="image-show" @click="showImageDemo('zbzm')">（示例:如图）</span>
              </h2>
              <van-field
                name="xingshizhengzbzmurl"
                :required="true"
                :rules="[{ required: true, message: '请上传行驶证机动车照片' }]"
              >
                <template #input>
                  <van-uploader
                    :max-size="10 * 1024 * 1024"
                    @oversize="onOversize"
                    max-count="1"
                    v-model="xsz_zb_zm_image"
                    :before-read="beforeRead"
                    :after-read="
                      ($event) => {
                        uploadImg($event, 'xsz_zb_zm', 'xingshizhengzbzmurl', 'uploadXsz');
                      }
                    "
                    :before-delete="
                      () => {
                        removePic('xsz_zb_zm');
                      }
                    "
                  ></van-uploader>
                </template>
              </van-field>
            </div>
            <div class="jsz-front-info-box">
              <!--车头号-->
              <van-field
                v-model="chetouhao"
                name="chetouhao"
                required
                :value="chetouhao"
                :rules="[{ required: true, message: '请输入车头号' }]"
                placeholder="请输入"
              >
                <template #label>
                  <span class="input-left-label-hq">车头号</span>
                </template>
              </van-field>
              <!--车辆识别代号(默认隐藏-->
              <van-field
                v-show="false"
                v-model="chejiahao"
                name="chejiahao"
                :value="chejiahao"
                placeholder="请输入"
              >
                <template #label>
                  <span class="input-left-label-hq">车辆识别代号</span>
                </template>
              </van-field>
              <!--所属车队-->
              <van-field
                v-model="sscd"
                name="sscd"
                required
                :value="sscd"
                :rules="[{ required: true, message: '请输入所属车队' }]"
                placeholder="请输入"
              >
                <template #label>
                  <span class="input-left-label-hq">所属车队</span>
                </template>
              </van-field>
              <!--车头质量-->
              <van-field
                v-if="usageType === '2'"
                v-model="ctzl"
                name="ctzl"
                type="number"
                :value="ctzl"
                placeholder="请输入"
              >
                <template #extra>
                  <div class="unit">KG</div>
                </template>
                <template #label>
                  <span class="input-left-label-hq">车头质量(单车填写)</span>
                </template>
              </van-field>
              <!--整备质量-->
              <van-field
                v-if="usageType === '2'"
                v-model="zhengbeizhiliang"
                name="zhengbeizhiliang"
                required
                :value="zhengbeizhiliang"
                :rules="[
                  {
                    required: true,
                    validator: validate_zhengbeizhiliang,
                    message: '请输入整备质量',
                  },
                ]"
                type="number"
                placeholder="请输入"
              >
                <template #extra>
                  <div class="unit">KG</div>
                </template>
                <template #label>
                  <span class="input-left-label-hq">整备质量</span>
                </template>
              </van-field>
              <!--总质量-->
              <van-field
                v-if="usageType === '2'"
                v-model="zongzhiliang"
                name="zongzhiliang"
                type="number"
                :value="zongzhiliang"
                placeholder="请输入"
              >
                <template #extra>
                  <div class="unit">KG</div>
                </template>
                <template #label>
                  <span class="input-left-label-hq">总质量(单车填写)</span>
                </template>
              </van-field>
              <!--行驶证核定载质量-->
              <van-field
                v-if="usageType === '2'"
                v-model="xingshizhenghdzzl"
                name="xingshizhenghdzzl"
                type="number"
                :value="xingshizhenghdzzl"
                required
                :rules="[{ required: true, message: '请输入行驶证核定载质量' }]"
                placeholder="请输入"
              >
                <template #extra>
                  <div class="unit">吨</div>
                </template>
                <template #label>
                  <span class="input-left-label-hq">行驶证核定载质量(单车填写)</span>
                </template>
              </van-field>
              <!--行驶证有效期时间选择器-->
              <ChoseTime
                v-if="usageType === '2'"
                name="xingshizhengyxq"
                label="行驶证有效期"
                @update:modelValue="xingshizhengyxq = $event"
                :modelValue="xingshizhengyxq"
              />
            </div>
          </div>
        </van-cell-group>
        <!--蒸洗+装卸表单内容-->
        <van-cell-group v-if="usageType === '2'" inset style="margin-top: 1rem">
          <div class="upload-box">
            <!--道路运输证正本正面图片-->
            <h2 class="upload-titile input-title-hq">
              道路运输证正本正面图片
              <span class="image-show" @click="showImageDemo('dlyszm')">（示例:如图）</span>
            </h2>
            <van-field
              name="daoluyszzbzmurl"
              :required="true"
              :rules="[{ required: true, message: '请上传道路运输证正本正面图片' }]"
            >
              <template #input>
                <van-uploader
                  :max-size="10 * 1024 * 1024"
                  @oversize="onOversize"
                  max-count="1"
                  v-model="dlys_zm_image"
                  :before-read="beforeRead"
                  :after-read="
                    ($event) => {
                      uploadImg($event, 'dlys_zm', 'daoluyszzbzmurl', 'uploadDlys');
                    }
                  "
                  :before-delete="
                    () => {
                      removePic('dlys_zm');
                    }
                  "
                ></van-uploader>
              </template>
            </van-field>
            <!--道路运输证（待理证）正面图片-->
            <h2 class="upload-titile input-title-hq title-extend">
              道路运输证（待理证）正面图片
              <span>
                （车辆信息和经营范围2页拍在一起）
                <span class="image-show" @click="showImageDemo('dlczm')">（示例:如图）</span>
              </span>
            </h2>
            <van-field
              name="daoluyszdlzmurl"
              :required="true"
              :rules="[{ required: true, message: '道路运输证（待理证）正面图片' }]"
            >
              <template #input>
                <van-uploader
                  :max-size="10 * 1024 * 1024"
                  @oversize="onOversize"
                  max-count="1"
                  v-model="dcl_zm_image"
                  :before-read="beforeRead"
                  :after-read="
                    ($event) => {
                      uploadImg($event, 'dcl_zm', 'daoluyszdlzmurl', 'uploadDcl');
                    }
                  "
                  :before-delete="
                    () => {
                      removePic('dcl_zm');
                    }
                  "
                ></van-uploader>
              </template>
            </van-field>

            <!--道路运输证(待理证)反面图片-->
            <h2 class="upload-titile input-title-hq title-extend">
              道路运输证（待理证）反面图片
              <span class="image-show" @click="showImageDemo('dlcfm')">（示例:如图）</span>
            </h2>
            <van-field
              name="daoluyszdlfmurl"
              :required="true"
              :rules="[{ required: true, message: '道路运输证（待理证）反面图片' }]"
            >
              <template #input>
                <van-uploader
                  :max-size="10 * 1024 * 1024"
                  @oversize="onOversize"
                  max-count="1"
                  v-model="dcl_fm_image"
                  :before-read="beforeRead"
                  :after-read="
                    ($event) => {
                      uploadImg($event, 'dcl_fm', 'daoluyszdlfmurl', 'uploadDcl');
                    }
                  "
                  :before-delete="
                    () => {
                      removePic('dcl_fm');
                    }
                  "
                ></van-uploader>
              </template>
            </van-field>

            <!--道路运输证有效期-->
            <ChoseTime
              @update:modelValue="daoluyszyxq = $event"
              :modelValue="daoluyszyxq"
              name="daoluyszyxq"
              label="道路运输证有效期"
              :required="false"
            />
            <!--选择经营范围-->
            <ChosePz
              name="daoluyszjyfw"
              title="道路运输证经营范围"
              :options="varietyList"
              :required="true"
              :modelValue="selectedData"
              @update:modelValue="selectedData = $event"
            />
            <van-field
              v-model="beizhu"
              autosize
              name="beizhu"
              type="textarea"
              rows="3"
              maxlength="50"
              placeholder="请输入备注"
              :value="beizhu"
            >
              <template #label>
                <span class="input-left-label-hq">备注</span>
              </template>
            </van-field>
          </div>
        </van-cell-group>
        <!--提交按钮-->
        <div style="margin: 1rem">
          <van-button
            round
            block
            type="info"
            native-type="submit"
            class="addBtn"
            @loading="loadingBtn"
            color="#316892"
          >
            保存
          </van-button>
        </div>
      </van-form>
    </div>
    <Tabbar></Tabbar>
  </div>
</template>

<script>
  import api from '@/fetch/api';
  import autoSubmitBeian from '@/mixins/autoSubmitBeian';
  import { Toast, Dialog, ImagePreview } from 'vant';
  import ChoseVehicleUsage from '../Public/choseVehicleUsageNew.vue';
  import ChoseTime from '../Public/choseTimeNew.vue';
  import ChosePz from '../Public/chosePzNew.vue';
  import Compressor from 'compressorjs';
  import Tabbar from '../Public/tabbarTpl.vue';
  export default {
    mixins: [autoSubmitBeian],
    components: {
      ChoseTime,
      ChosePz,
      Tabbar,
      ChoseVehicleUsage,
    },
    data() {
      return {
        detailInfo: {}, // 车头详情
        // ---------------------------------------------表单(仅蒸洗部分
        xsz_zb_fm_url: '', // 行驶证正页url
        xsz_zb_fm_image: [], // 行驶证正页照片
        chetouhao: '', //车头号
        sscd: '', //所属车队

        // ---------------------------------------------表单(仅蒸洗+装卸
        xsz_fb_zm_url: '', // 行驶证副页正面url
        xsz_fb_zm_image: [], // 行驶证副页正面照片
        xsz_fb_fm_url: '', // 行驶证副页反面url
        xsz_fb_fm_image: [], // 行驶证副页反面照片
        xsz_zb_zm_url: '', // 行驶证机动车url
        xsz_zb_zm_image: [], // 行驶证机动车照片
        ctzl: 0, //车头质量
        zhengbeizhiliang: 0, //整备质量
        zongzhiliang: 0, //总质量
        xingshizhenghdzzl: 0, //行驶证核定载质量
        xingshizhengyxq: '', //行驶证有效期
        chejiahao: '', //车辆识别代号
        dlys_zm_url: '', // 道路运输证正面url
        dlys_zm_image: [],
        dcl_zm_url: '', // 待理证正面url
        dcl_zm_image: [],
        dcl_fm_url: '', //待理证反面url
        dcl_fm_image: [],
        daoluyszhao: '', //道路运输证号
        daoluyszyxq: '', //道路运输证有效期
        daoluyszjyfw: '', //道路运输证经营范围Str
        selectedData: [], //道路运输证经营范围Arr
        beizhu: '', // 备注

        // ---------------------------------------------其他
        api: {
          uploadDcl: api.uploadDcl,
          uploadDlys: api.uploadDlys,
          uploadXsz: api.uploadXsz,
        },
        loadingBtn: false,
        // 车辆用途列表
        usageList: [],
        // 车辆用途类型
        usageType: '',
        // 经营范围品种
        varietyList: [],
        // 车辆用途禁用项
        usageDisabled: false
      };
    },
    created() {
      document.title = '编辑车头信息';
      // 获取车辆详情信息
      this.getChetouBeianDetail();
    },
    methods: {
      // 获取车头详情信息
      async getChetouBeianDetail() {
        try {
          await this.getUsage(); //获取车辆用途选项
          await this.fetchPzList(); // 获取道路经营范围品种
          const openid = this.$store.state.wx_info.openid;
          const res = JSON.parse(await api.getChetouBeianDetail(openid));
          if (res.respCode !== '0' && res.respCode !== 0) return;
          const { data: detail } = res;
          // 用途类型
          this.usageType = detail.vehicleUsage;
          this.usageDisabled = detail.vehicleUsage === '2'
          Object.assign(this.detailInfo, detail);
          this.mergeinfo(detail);
        } catch (err) {
          Toast.fail('连接失败，请刷新页面');
        }
      },

      // 获取经营范围品种
      async fetchPzList() {
        try {
          const res = JSON.parse(await api.getPzList());
          if (res.respCode === '0') {
            this.varietyList = res.data;
          } else {
            Dialog.alert({
              message: res.message,
            }).then(() => {
              this.$router.push({
                name: 'index',
              });
            });
          }
        } catch (err) {
          console.log(err);
          Toast.fail('连接失败，请刷新页面');
        }
      },

      // 获取车辆用途
      async getUsage() {
        try {
          const res = JSON.parse(await api.getTypeList('vehicleUsage'));
          if (res.success) {
            this.usageList = res.obj.filter((item) => {
              return item.typecode !== '';
            });
          } else {
            Toast.fail(res.message);
          }
        } catch (e) {
          console.log('获取车辆用途失败', e);
        }
      },

      // 改变车辆用途事件
      changeVehicleUsage(val) {
        this.mergeinfo(this.detailInfo); // 全部重置
        // if (val === '1') {
        //   this.setFormPartB(this.detailInfo); // 仅重置装卸货部分
        // }
      },

      // 上传前钩子函数
      beforeRead(file) {
        let quality = 0.6;
        if (file.size < 4 * 1024 * 1024) {
          quality = 0.9;
        } else if (file.size >= 4 * 1024 * 1024 && file.size < 8 * 1024 * 1024) {
          quality = 0.8;
        } else {
          quality = 0.6;
        }
        return new Promise((resolve, reject) => {
          // compressorjs 默认开启 checkOrientation 选项
          // 会将图片修正为正确方向
          new Compressor(file, {
            quality: quality,
            success(result) {
              let newfile = new File([result], file.name, {
                type: file.type,
              });
              resolve(newfile);
            },
            error(error) {
              Toast.fail(error);
              reject(error);
            },
          });
        });
      },

      onOversize() {
        Toast('文件大小不能超过 10Mb');
      },

      // 图片回显方法
      showImgByUrl(imgName, url) {
        this[imgName].length = 0;
        if (url) {
          this[imgName].push({
            url: this.GLOBAL.weburl + '/' + url,
          });
        }
      },

      // 整备质量校验
      validate_zhengbeizhiliang(val, rule) {
        rule.message = '请填写正确的整备质量';
        return !(parseFloat(val) <= 0);
      },

      // 校验失败时触发:失败提示
      formCheckFailed(errorInfo) {
        // console.log(errorInfo.errors);
        Toast.fail(errorInfo.errors[0].message);
      },

      // 校验通过时触发:提交表单
      async submitJsy(values) {
        try {
          this.loadingBtn = true;
          const formData = JSON.stringify({
            id: this.$route.params.id,
            openid: this.$store.state.wx_info.openid,
            vehicleUsage: this.usageType,
            chetouhao: values.chetouhao,
            xingshizhengyxq: this.xingshizhengyxq,
            sscd: values.sscd,
            ctzl: values.ctzl,
            zhengbeizhiliang: values.zhengbeizhiliang,
            zongzhiliang: values.zongzhiliang,
            chejiahao: values.chejiahao,
            xingshizhenghdzzl: values.xingshizhenghdzzl,
            xingshizhengzbfmurl: this.xsz_zb_fm_url,
            xingshizhengfbzmurl: this.xsz_fb_zm_url,
            xingshizhengfbfmurl: this.xsz_fb_fm_url,
            xingshizhengzbzmurl: this.xsz_zb_zm_url,
            daoluyszhao: this.daoluyszhao,
            daoluyszjyfw: this.selectedData.length > 0 ? this.selectedData.join('|') : '',
            daoluyszyxq: this.daoluyszyxq,
            daoluyszzbzmurl: this.dlys_zm_url,
            daoluyszdlzmurl: this.dcl_zm_url,
            daoluyszdlfmurl: this.dcl_fm_url,
            beizhu: values.beizhu,
          });
          const res = JSON.parse(await api.updateBeianChetou(formData));
          if (res.respCode === '0') {
            // 清掉首页车辆缓存，让回首页时重新拉最新行驶证有效期
            localStorage.removeItem('vehicleInfo');
            this.autoSubmitBeian('chetou', this.$route.params.id, 'chetouList');
          } else {
            Toast.fail(res.message);
          }
        } catch (error) {
          Toast.fail('提交表单失败，请刷新页面');
        } finally {
          this.loadingBtn = false;
        }
      },

      // 填充表单信息(全部
      mergeinfo(detail) {
        this.setFormPartA(detail);
        this.setFormPartB(detail);
      },

      // 填充表单信息(仅蒸洗部分
      setFormPartA(detail) {
        // 行驶证正本正页
        detail.xingshizhengzbfmurl != null && (this.xsz_zb_fm_url = detail.xingshizhengzbfmurl);
        this.showImgByUrl('xsz_zb_fm_image', detail.xingshizhengzbfmurl);
        detail.chetouhao != null && (this.chetouhao = detail.chetouhao);
        detail.sscd != null && (this.sscd = detail.sscd);
      },

      // 填充表单信息(仅装卸特部分
      setFormPartB(detail) {
        detail.xingshizhengfbzmurl != null && (this.xsz_fb_zm_url = detail.xingshizhengfbzmurl);
        this.showImgByUrl('xsz_fb_zm_image', detail.xingshizhengfbzmurl);
        detail.xingshizhengfbfmurl != null && (this.xsz_fb_fm_url = detail.xingshizhengfbfmurl);
        this.showImgByUrl('xsz_fb_fm_image', detail.xingshizhengfbfmurl);
        detail.xingshizhengzbzmurl != null && (this.xsz_zb_zm_url = detail.xingshizhengzbzmurl);
        this.showImgByUrl('xsz_zb_zm_image', detail.xingshizhengzbzmurl);
        detail.ctzl != null && (this.ctzl = detail.ctzl);
        detail.zhengbeizhiliang != null && (this.zhengbeizhiliang = detail.zhengbeizhiliang);
        detail.zongzhiliang != null && (this.zongzhiliang = detail.zongzhiliang);
        detail.xingshizhenghdzzl != null && (this.xingshizhenghdzzl = detail.xingshizhenghdzzl);
        detail.xingshizhengyxq != null && (this.xingshizhengyxq = detail.xingshizhengyxq);
        detail.daoluyszzbzmurl != null && (this.dlys_zm_url = detail.daoluyszzbzmurl);
        this.showImgByUrl('dlys_zm_image', detail.daoluyszzbzmurl);
        detail.daoluyszdlzmurl != null && (this.dcl_zm_url = detail.daoluyszdlzmurl);
        this.showImgByUrl('dcl_zm_image', detail.daoluyszdlzmurl);
        detail.daoluyszdlfmurl != null && (this.dcl_fm_url = detail.daoluyszdlfmurl);
        this.showImgByUrl('dcl_fm_image', detail.daoluyszdlfmurl);
        detail.daoluyszyxq != null && (this.daoluyszyxq = detail.daoluyszyxq);
        detail.daoluyszjyfw != null && (this.daoluyszjyfw = detail.daoluyszjyfw);
        const pzArrayOld = this.daoluyszjyfw ? this.daoluyszjyfw.split('|') : [];
        this.selectedData = JSON.parse(JSON.stringify(pzArrayOld));
        detail.beizhu != null && (this.beizhu = detail.beizhu);
        detail.daoluyszhao != null && (this.daoluyszhao = detail.daoluyszhao);
        detail.chejiahao != null && (this.chejiahao = detail.chejiahao);
      },

      // 通用上传方法
      async uploadImg(file, type, field, fetchAPI) {
        try {
          file.status = 'uploading';
          file.message = '上传中...';
          let formData = new FormData();
          formData.append('uploadpics', file.file);
          formData.append('ctid', '');
          const args = fetchAPI === 'uploadDlys' ? [formData] : [type, formData];
          const res = JSON.parse(await api[fetchAPI](...args));
          const imageData = res?.data; // 获取OCR识别信息
          // 处理无数据情况
          if (!imageData) {
            setTimeout(() => {
              file.status = 'failed';
              file.message = '上传失败';
            }, 1000);
            Toast.fail(`上传图片失败，${res.message}`);
            return;
          }
          if (res.respCode === '0') {
            this[`${type}_url`] = imageData[field] || ''; // 设置图片url
            this.showImgByUrl(`${type}_image`, imageData[field]); // 回显图片
            // ---------- 根据不同类型设置自定义逻辑START ----------
            if (type === 'dlys_zm' || type === 'dcl_zm' || type === 'dcl_fm') {
              this.daoluyszyxq = imageData?.daoluyszyxq || ''; // 设置道路运输证有效期
              // 道路运输证 对比车头号和识别到的车头号
              if (this.chetouhao && this.chetouhao !== imageData.chetouhao) {
                setTimeout(() => {
                  file.status = 'failed';
                  file.message = '上传失败';
                }, 1000);
                Toast.fail('上传图片失败，证件车辆与登记车头号不符合');
                return;
              }
            } else if (type === 'xsz_fb_zm') {
              // 行驶证副本正面
              if (imageData.bpmStatus === '3') {
                this.mergeinfo(imageData);
              } else {
                imageData.ctzl != null && (this.ctzl = imageData.ctzl); //车头质量
                imageData.xingshizhengyxq != null &&
                  (this.xingshizhengyxq = imageData.xingshizhengyxq); //行驶证有效期
                imageData.zhengbeizhiliang != null &&
                  (this.zhengbeizhiliang = imageData.zhengbeizhiliang); //整备质量
                imageData.zongzhiliang != null && (this.zongzhiliang = imageData.zongzhiliang); //总质量
                imageData.xingshizhenghdzzl != null &&
                  (this.xingshizhenghdzzl = imageData.xingshizhenghdzzl); //行驶证核定载质量
              }
            } else if (type === 'xsz_zb_fm') {
              // 行驶证正本反面
              if (imageData.bpmStatus === '3') {
                this.mergeinfo(imageData);
              } else {
                this.xsz_zb_fm_url = imageData.xingshizhengzbfmurl || '';
                imageData.chetouhao != null && (this.chetouhao = imageData.chetouhao); //车头号
                imageData.sscd != null && (this.sscd = imageData.sscd); //所属车队
                imageData.chejiahao != null && (this.chejiahao = imageData.chejiahao); //车辆识别代号
              }
            }
            // ---------- 根据不同类型设置自定义逻辑END ----------
            file.status = 'success';
            file.message = '上传成功';
          } else if (
            res.respCode === '-1' &&
            (type === 'dlys_zm' || type === 'dcl_zm' || type === 'dcl_fm')
          ) {
            this.dlys_zm_url = imageData.daoluyszzbzmurl || '';
            this.showImgByUrl(`dlys_zm_image`, imageData.daoluyszzbzmurl);
            file.status = 'success';
            file.message = '上传成功';
          }
        } catch (e) {
          Toast.fail('上传图片失败，' + e);
          setTimeout(() => {
            file.status = 'failed';
            file.message = '上传失败';
          }, 1000);
        }
      },

      // 移除图片
      removePic(field) {
        this[`${field}_url`] = '';
        this[`${field}_image`] = [];
      },

      // 展示示例图片
      showImageDemo(type) {
        let images = [];
        switch (type) {
          case 'zbzm':
            images = [require('@/assets/images/ctsl.png')];
            break;
          case 'zbfm':
            images = [require('@/assets/images/zbfm.png')];
            break;
          case 'fbzm':
            images = [require('@/assets/images/fbzm.png')];
            break;
          case 'fbfm':
            images = [require('@/assets/images/fbfm.png')];
            break;
          case 'dlyszm':
            images = [require('@/assets/images/ctdlyszm.png')];
            break;
          case 'dlczm':
            images = [require('@/assets/images/ctdlczm.jpg')];
            break;
          case 'dlcfm':
            images = [require('@/assets/images/dlcfm.jpg')];
            break;
        }
        // 图片预览
        ImagePreview({
          images: images,
          closeable: true,
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
  .content {
    margin-top: 1rem;
    margin-bottom: 3.75rem;
    padding-bottom: env(safe-area-inset-bottom);
  }

  .upload-box {
    //border-top: 1px solid #ececec;
    background: #fff;
    margin-top: 0.625rem;
    .upload-titile {
      padding: 0.675rem 1rem;
      .image-show {
        margin-left: 0.5rem;
        color: #2440b3;
      }
    }
    .title-extend {
      line-height: 1.5;
    }
    .upload-xsz-box {
      margin-left: 1rem;
    }
    .upload-dlysz-box {
      margin-left: 1rem;
    }
  }

  .pz-box {
    .van-checkbox-group {
      margin-left: 1rem;
    }
  }

  .unit {
    padding-left: 0.2rem;
    color: #969799;
  }

  .red-required::before {
    position: absolute;
    left: 8px;
    color: #ee0a24;
    font-size: 14px;
    content: '*';
  }
</style>
